// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "vendor/bootstrap.js"
import Home from "js/home"
import Survey from "js/survey"
import Testimonials from "../js/testimonials"

Rails.start()
ActiveStorage.start()

window.Home = Home
window.Survey = Survey
window.Testimonials = Testimonials

const images = require.context('../images', true)